<template>
<div class="mini-banner">
  <div class="mini-banner__image">
    <img class="mini-banner__image-pic" alt="banner" :src="urlPicture">
  </div>

  <div class="mini-banner__icon" v-show="bannerIconShow">
    <img class="mini-banner__icon-pic" alt="banner-icon" :src="urlIcon">
  </div>

  <div class="mini-banner__vector" v-show="bannerVectorShow">
    <img class="mini-banner__vector-pic" alt="banner-icon" :src="urlVector">
  </div>

  <h1 class="mini-banner__title">
    <div class="mini-banner__date" v-if="newsPage">{{ newsDate }}</div>
    <div>
      <slot></slot>
    </div>
  </h1>
</div>
</template>

<script>
export default {
  props: {
    urlPicture: {
      type: String,
      default() {
        return '';
      },
    },
    urlIcon: {
      type: String,
      default() {
        return '';
      },
    },
    urlVector: {
      type: String,
      default() {
        return '';
      },
    },
    bannerIconShow: {
      type: Boolean,
      default: true,
    },
    bannerVectorShow: {
      type: Boolean,
      default: true,
    },
    newsPage: {
      type: Boolean,
      default: false,
    },
    newsDate: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {};
  },

};
</script>

<style lang="scss" scoped>
$light-gray: #D5D6D7;
$white: #FFFFFF;

.mini-banner {
  position: relative;
  z-index: 1;
  overflow: hidden;

  &__image {
    height: 400px;

    @media (max-width: 1500px) {
      height: 300px;
    }

    @media (max-width: 720px) {
      height: 210px;
    }

    .contacts & {
      @media (max-width: 480px) {
        height: 160px;
      }

      @media (max-width: 360px) {
        height: 140px;
      }
    }

    &-pic {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__date {
    background: #FFFFFF;
    border-radius: 10px;
    padding: 10px 15px;
    color: #4DB6BC;
    font-size: 14px;
    line-height: 22px;
    font-family: "montserratbold", sans-serif;
    display: inline-block;
    margin: 0 0 30px;

    @media (max-width: 720px) {
      font-size: 12px;
      line-height: 12px;
      margin: 0 0 20px;
      padding: 10px;
    }
  }

  &__title {
    position: absolute;
    font-family: 'montserratbold', sans-serif;
    font-size: 40px;
    line-height: 46px;
    color: $white;
    bottom: 39px;
    left: 180px;
    max-width: 60%;

    .news-details__banner & {
      max-width: 85%;

      @media (max-width: 720px) {
        font-size: 16px;
        line-height: 20px;
        bottom: 10px;
      }
    }

    @media (max-width: 1275px) {
      bottom: 15px;
      left: 3%;
    }

    @media (max-width: 1224px) {
      .news-details__banner & {
        max-width: 80%;
      }
    }

    @media (max-width: 1160px) {
      font-size: 26px;
      line-height: 28px;
    }

    @media (max-width: 720px) {
      font-size: 18px;
      line-height: 22px;
      bottom: 10px;
    }
  }

  &__vector {
    position: absolute;
    top: -27px;

    .duble-grafic & {
      width: 100%;
    }

    @media (max-width: 580px) {
      top: 20px;
    }

    &-pic {
      width: 100%;
    }
  }

  &__icon {
    position: absolute;
    z-index: 20;
    right: 180px;
    bottom: 39px;

    &-pic {
      width: 100%;
    }

    .shadow-icon & {
      background: rgba(43, 49, 56, 0.7);
      padding: 20px;
      border-radius: 12px;

      @media (max-width: 1275px) {
        padding: 15px;
      }
    }

    @media (max-width: 1275px) {
      bottom: 15px;
      right: 3%;
      width: 85px;
    }

    @media (max-width: 720px) {
      bottom: 10px;
    }
  }
}
</style>
